import { calculateTaxBracket } from "./taxBracketCalculator"

export function calculateSmallBusinessTax (
    entityType: string,
    filingStatus: string,
    revenue: number,
    totalExpenses: number,
    mealsAndEntertainmentExpenses: number,
    estimatedTaxPayments: number
) {
    // define main variables
    let preTax = 0;
    let standardDeduction: number;
    let finalNum: number;

    // define variables for corporations
    let corporateRate = 0.21;
    const applyCorporateRate =
    entityType === 'C-Corporation' || entityType === 'LLC - C-Corp'

    preTax = revenue - (totalExpenses - mealsAndEntertainmentExpenses) - mealsAndEntertainmentExpenses * 0.5

    // if business is corporation, apply corporate rate and calculate final num
    if (applyCorporateRate) {
        finalNum = preTax * corporateRate - estimatedTaxPayments;
        return finalNum;
    } else {
        if (filingStatus) {
          switch (filingStatus) {
            case "s":
            case "mfs":
              standardDeduction = 12000
              break;
            case "hh":
              standardDeduction = 18000
              break;
            case "mfj":
            case "qw":
              standardDeduction = 24000
              break;
        }

        // final pre tax income (subtract standard deduction)
        preTax = preTax - standardDeduction;
    
        const calculatedTaxBracket = calculateTaxBracket(preTax, 2020, filingStatus);
        
        finalNum = preTax * (calculatedTaxBracket / 100) - estimatedTaxPayments;

        }

        return finalNum;

    }
    
}